import React, { memo } from "react";
import { AvGroup } from "availity-reactstrap-validation";
import { StyledLabel, StyledSelectInput } from "@aureskonnect/react-ui";
import classnames from "classnames";
import { ValidationMessage } from "./ValidationMessage";
import { LANGUAGES } from "@constants/index";
import { translatedPaymentMethod } from "../../hooks";

export const PaymentMethodField = memo(
    ({
        t,
        paymentMethodList,
        choiceMode,
        setChoiceMode,
        paymentMethod,
        setDisplay,
        setAdvancedDisplayName,
        setIsEdited,
        inputChoiceMode,
        setInputChoiceMode,
        isNameExist,
        advancedDisplayName,
        display,
    }: any) => {
        return (
            <AvGroup>
                <StyledLabel htmlFor="text" className="required__clz mt-3">
                    {t("Payment method")}
                </StyledLabel>

                <StyledSelectInput
                    isClearable
                    className={classnames("mdr_inp_FRpaymentMethod", {
                        invalid__clz: inputChoiceMode || isNameExist,
                        "not-allowed-input__clz":
                            paymentMethod?.id !== undefined,
                    })}
                    options={paymentMethodList.map((opt: any) => ({
                        ...opt,
                        isDisabled: !["Cash-1", "Credit-card-4"].includes(
                            opt.value
                        ),
                    }))}
                    placeholder={`${t("Select")}…`}
                    value={
                        choiceMode
                            ? { label: t(choiceMode), value: t(choiceMode) }
                            : null
                    }
                    onChange={(e: any) => {
                        e !== null ? setChoiceMode(e.label) : setChoiceMode("");
                        setIsEdited(true);
                        setInputChoiceMode(false);
                        if (e === null && display === "") {
                            setAdvancedDisplayName({
                                languages: LANGUAGES,
                            });
                        } else if (e !== null) {
                            setAdvancedDisplayName({
                                ...advancedDisplayName,
                                languages: translatedPaymentMethod[e.label],
                            });
                            setDisplay(e.label);
                        }
                    }}
                />

                {inputChoiceMode ? (
                    <ValidationMessage
                        condition={inputChoiceMode}
                        text={t("Please select a payment method")}
                    />
                ) : null}
                {isNameExist ? (
                    <ValidationMessage
                        condition={isNameExist}
                        text={t("The payment method already exists")}
                    />
                ) : null}
            </AvGroup>
        );
    }
);
